<template>
	<NuxtIcon :name="'local:' + name" class="sh-icon" :size />
</template>

<script setup lang="ts">
export type ShIcon = {
	name: string;
	size?: string;
};

withDefaults(defineProps<ShIcon>(), {
	size: '24px'
});
</script>

<style lang="scss" scoped>
.sh-icon {
	width: var(--icon-width, 24px);
	height: var(--icon-height, 24px);
}
</style>
